import { normalize } from 'normalizr';
import { Fetch, fetchAction } from 'barnyard/utils';
import * as constants from '../constants';

export const checkValidIncentive = (unique_id, before, resultCallback) => Fetch({
  url: `/api/incentives/code/${unique_id}/valid/`,
  before,
  success: resultCallback,
  failure: resultCallback
});

export const incentiveBuyersFetch = () => (dispatch) => {
  fetchAction(
    dispatch,
    constants.INCENTIVE_BUYERS_FETCH,
    {},
    {
      url: '/api/incentives/buyers/',
      success: (result) => {
        const normalized = normalize(result, [constants.schema.incentiveBuyer]);
        dispatch({
          type: constants.INCENTIVE_BUYERS_FETCH.success,
          entities: normalized.entities,
          ids: normalized.result
        });
      }
    }
  );
};


export const incentiveBuyersDismiss = incentiveBuyerId => (dispatch) => {
  fetchAction(
    dispatch,
    constants.INCENTIVE_BUYERS_UPDATE,
    {},
    {
      url: `/api/incentives/buyers/${incentiveBuyerId}/`,
      method: 'PATCH',
      body: { should_show_banner: false },
      success: (result) => {
        const normalized = normalize(result, constants.schema.incentiveBuyer);
        dispatch({
          type: constants.INCENTIVE_BUYERS_UPDATE.success,
          entities: normalized.entities,
          ids: normalized.result
        });
      }
    }
  );
};


export const referralBuyerIncentiveFetch = () => dispatch => fetchAction(
  dispatch,
  constants.REFERRAL_BUYER_INCENTIVE_FETCH,
  {},
  {
    url: '/api/incentives/referral/'
  }
);
